const LOG_LEVELS = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
}

// Determine if we're on the server
const isServer = typeof window === 'undefined'

function formatLog(level, event, data = {}) {
  return {
    timestamp: new Date().toISOString(),
    level,
    event,           // Always a dot-notated string: 'scan.completed'
    service: 'expirydesk',
    environment: process.env.NODE_ENV,
    ...data,
    // Never log these fields even if accidentally passed:
    password: undefined,
    token: undefined,
    secret: undefined,
    apiKey: undefined,
  }
}

export const logger = {
  
  debug(event, data) {
    if (process.env.NODE_ENV !== 'development') return
    console.debug(JSON.stringify(formatLog(LOG_LEVELS.DEBUG, event, data)))
  },

  info(event, data) {
    const log = formatLog(LOG_LEVELS.INFO, event, data)
    console.log(JSON.stringify(log))
    // In production: send to logging service (Axiom/Logtail/etc)
    if (process.env.NODE_ENV === 'production' && isServer) {
      sendToLoggingService(log)
    }
  },

  warn(event, data) {
    const log = formatLog(LOG_LEVELS.WARN, event, data)
    console.warn(JSON.stringify(log))
    // Also add as Sentry breadcrumb
    if (typeof window !== 'undefined' || isServer) {
      try {
        const Sentry = require('@sentry/nextjs')
        Sentry.addBreadcrumb({
          category: event,
          level: 'warning',
          data,
        })
      } catch {}
    }
  },

  error(event, error, data = {}) {
    const log = formatLog(LOG_LEVELS.ERROR, event, {
      ...data,
      error_message: error?.message,
      error_name: error?.name,
      // Stack only in development — never in production logs
      ...(process.env.NODE_ENV === 'development' 
        ? { stack: error?.stack } 
        : {}),
    })
    console.error(JSON.stringify(log))
  },
}

// Stub — replace with Axiom, Logtail, or Papertrail in production
async function sendToLoggingService(log) {
  if (!process.env.LOGGING_ENDPOINT) return
  try {
    await fetch(process.env.LOGGING_ENDPOINT, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.LOGGING_API_KEY}`,
      },
      body: JSON.stringify(log),
    })
  } catch {
    // Never let logging break the app
  }
}
